<template>
  <div class="row" v-if="show">
    <div class="col-12">
      <fb-paginacion
        :total="transactionalityPagination.totalPaginas"
        :max="10"
        v-model="page"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';

export default {
  props: ['show', 'value'],
  components: { FbPaginacion },
  computed: {
    ...mapGetters('Operations', ['transactionalityPagination'])
  },
  watch: {
    page(newValue) {
      this.$emit('input', newValue);
    }
  },
  data() {
    return {
      page: this.value
    };
  }
};
</script>
